module.exports = __webpack_public_path__ + "img/2.504eb941.png";